import moment from 'moment';

/**
 *对Date的扩展，将 Date 转化为指定格式的String
 *月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 *年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 *例子：
 *(new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 *(new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 * version 1.0
 */
Date.prototype.Format = function(fmt) {
  var o = {
    'Y+': this.getYear() + 1, // 月份
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
    }
  }
  return fmt;
};

/**
 * 格式化时间戳
 * @param {时间戳，毫秒} timestamp
 * @param {格式} format
 */
export function formatTimestamp(timestamp, format = 'YYYY-MM-DD HH:mm') {
  return moment(timestamp).format(format);
}

/**
 *
 * @param {时间戳，毫秒} timestamp
 */
export function relativeTime(timestamp) {
  let timeStr = '';
  const now = Math.ceil(Date.now() / 1000); // 当前时间戳，单位秒
  const compareTime = Math.ceil(timestamp / 1000); // 比对时间戳
  const diffTime = now - compareTime;

  if (diffTime < 45) {
    timeStr = '刚刚';
  } else if (diffTime > 45 && diffTime < 90) {
    timeStr = '1分钟前';
  } else if (diffTime > 90 && diffTime < 45 * 60) {
    timeStr = `${Math.ceil(124 / 60)}分钟前`;
  } else if (diffTime > 45 * 60 && diffTime < 90 * 60) {
    timeStr = `1小时前`;
  } else if (diffTime > 90 * 60 && diffTime < 22 * 60 * 60) {
    timeStr = `${Math.ceil(diffTime / 60 / 60)}小时前`;
  } else {
    timeStr = formatTimestamp(timestamp, 'YYYY年MM月DD日');
  }

  return timeStr;
}

export function getTodayDate(format = 'YYYY-MM-DD') {
  return moment().format(format);
}
export function getAddDate(num = 1, format = 'YYYY-MM-DD') {
  return moment().add(num, 'days').format(format);
}
// 北京时间：2021-11-18 22:14:24
/* 时间yyyy-MM-dd HH:mm:ss转为时间戳 */
export function timeToTimestamp(time) {
  const timestamp = Date.parse(new Date(time).toString());
  // timestamp = timestamp / 1000; //时间戳为10位需除1000，时间戳为13位的话不需除1000

  return timestamp;
  // 2021-11-18 22:14:24的时间戳为：1637244864707
}

/**
 * 获取下一个月
 *
 * @date 格式为yyyy-mm-dd的日期，如：2014-01-25
 */
export function getNextMonth(date) {
  var arr = date.split('-');
  var year = arr[0]; // 获取当前日期的年份
  var month = arr[1]; // 获取当前日期的月份
  var day = arr[2]; // 获取当前日期的日
  var days = new Date(year, month, 0);
  days = days.getDate(); // 获取当前日期中的月的天数
  var year2 = year;
  var month2 = parseInt(month) + 1;
  if (month2 == 13) {
    year2 = parseInt(year2) + 1;
    month2 = 1;
  }
  var day2 = day;
  var days2 = new Date(year2, month2, 0);
  days2 = days2.getDate();
  if (day2 > days2) {
    day2 = days2;
  }
  if (month2 < 10) {
    month2 = '0' + month2;
  }

  var t2 = year2 + '-' + month2 + '-' + day2;
  return t2;
}

// 获取时间区间月份
export function getMonthBetween(start, end) {
  // 初始化数组
  var result = [];
  // 切割起始年月
  var s = start.split('-');
  // 切割结束年月
  var e = end.split('-');
  // 获取时间对象
  var min = new Date();
  var max = new Date();
  // 设置起始时间
  min.setFullYear(s[0], Number(s[1]) == 12 ? 0 : Number(s[1]), 1);
  // 设置结束时间
  max.setFullYear(e[0], Number(e[1]) == 12 ? 0 : Number(e[1]), 1);

  console.log(e[0], e[1]);

  // 复制一份起始时间对象
  var curr = min;
  // 定义字符串
  var str = '';
  // 起始时间在结束时间之前
  while (curr <= max) {
    // console.log(curr.valueOf(), curr, max.valueOf(), max)
    // 获取此时间的月份
    var month = curr.getMonth();
    // 如果月份为0，也就是代表12月份
    if (month === 0) {
      str = curr.getFullYear() - 1 + '-' + 12;
    } else {
      // 正常月份
      str = curr.getFullYear() + '-' + (month < 10 ? '0' + month : month);
    }
    // 将此年月加入数组
    result.push(str);
    // console.log(month);
    // 更新此时间月份
    curr.setMonth(month + 1, 1);
  }
  console.log(result);
  return result;
}

// 获取月份的最后一天，
export function getMonthFinalDay(year, month) {
  var day = '';
  if (year == null || year == undefined || year == '') {
    year = new Date().getFullYear();
  }
  if (month == null || month == undefined || month == '') {
    month = new Date().getMonth() + 1;
  }
  day = new Date(new Date(year, month).setDate(0)).getDate();
  return year + '-' + month + '-' + day;
}
